import { AzureAuth } from './core/auth/azure/AzureAuth';
import { SmukApi } from './utils/SmukApi';
import config from './utils/SmukConfig';

interface IContext {
	auth: AzureAuth;
	smukAPI: SmukApi;
}

const auth: AzureAuth = new AzureAuth(config.authConfig);

export const context: IContext = {
	auth: auth,
	smukAPI: new SmukApi(config, auth),
};
